export default "__VITE_ASSET__0d788853__"